const eventColorMappings = {
  Draf: 'gray',
  Dijadwalkan: 'purple',
  Perjalanan: 'blue',
  Selesai: 'green',
  Bermasalah: 'red',
}

export default eventColorMappings